import { ErrorModal } from "@dexteel/mesf-core";
import { CircularProgress, TextField } from "@mui/material";
import { Autocomplete } from "@mui/material";
import { get } from "lodash-es";
import { useEffect, useState } from "react";
import type { FieldError } from "react-hook-form";
import type { Mold } from "../model/Mold";
import { getMolds } from "../repositories/MoldRepository";

type Props = {
  label: string;
  value: number | null;
  onChange?: Function;
  fieldError: FieldError | undefined;
  disabled?: boolean;
};

export const MoldAutocomplete = ({
  label,
  value,
  onChange = () => {},
  fieldError,
  disabled = false,
}: Props) => {
  const [molds, setMolds] = useState<Mold[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState("");

  const loadData = async () => {
    setIsLoading(true);
    setError("");
    const resp = await getMolds();
    if (resp.ok) {
      const rows = get(resp, "data.tables[0].rows", []) as Mold[];
      setMolds(rows);
    } else {
      setError(resp.message);
    }
    setIsLoading(false);
  };

  const selectedValue = molds?.find((ms: Mold) => ms.MoldId === value) || null;

  useEffect(() => {
    loadData().then(() => {});
    return;
  }, []);

  return (
    <>
      <Autocomplete
        id="clear-on-escape"
        clearOnEscape
        options={molds ?? []}
        getOptionLabel={(option) => option.MoldName}
        onChange={(event, newValue) => {
          onChange(newValue ? newValue.MoldId : null);
        }}
        renderInput={(params) => (
          <>
            <TextField
              {...params}
              label={label}
              variant="outlined"
              size="small"
              fullWidth
              error={!!fieldError}
              helperText={fieldError?.message}
              slotProps={{
                input: {
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {isLoading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : (
                        params.InputProps.endAdornment
                      )}
                    </>
                  ),
                },
              }}
            />
          </>
        )}
        disabled={disabled}
        value={selectedValue}
      />
      <ErrorModal error={error} onHide={() => setError("")} />
    </>
  );
};
